import { AppEntity, ContactInformationSchema, PostalAddressSchema } from '@app/icare/db/schema/common'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'

export const MedicalSupplyHomeId = entityId('medicalSupplyHome')

export type MedicalSupplyHomeIdType = typeof MedicalSupplyHomeId.Type

export const MedicalSupplyHomeSchema = AppEntity.extend({
  id: MedicalSupplyHomeId.schema,
  name: z.string().min(1).max(255),
  comment: z.string().nullish(),
  remarks: z.string().nullish(),
  serviceArea: z.string().max(255).nullish(),
  address: PostalAddressSchema.nullish(),
  contact: ContactInformationSchema.nullish(),
})

export type MedicalSupplyHome = z.infer<typeof MedicalSupplyHomeSchema>
